import { BaseElementWithoutShadowDOM } from '@theme/base-element'

export class BackToTop extends BaseElementWithoutShadowDOM {
  constructor() {
    super(...arguments)

    this.offset = 0
  }
  get progressWrap() {
    return this.renderRoot?.querySelector('back-to-top') ?? null
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties)

    this.updateOffset()

    window.addEventListener('scroll', this.handleScroll.bind(this))
    window.addEventListener('resize', this.updateOffset.bind(this))
    this.addEventListener('click', this.scrollToTop.bind(this))
    this.addEventListener('keypress', this.handleKeyPress.bind(this))
  }

  updateOffset() {
    this.offset = document.documentElement.scrollHeight * 0.3
  }

  handleScroll() {
    if (window.scrollY > this.offset) {
      this.classList.remove('hidden')
    } else {
      this.classList.add('hidden')
    }
  }

  scrollToTop(event) {
    event.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  handleKeyPress(event) {
    if (
      event.key === 'Enter' ||
      event.key === ' ' ||
      event.key === 'Spacebar'
    ) {
      event.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }
}

customElements.define('back-to-top', BackToTop)
